<template>

  <transition name="fade">
    <div class="filterbarpop-wrap" v-if="visible" ><!-- :style="{'top': bgTop + 'px'}" -->
      <div class="filterbarpop-bg" @touchmove.prevent id="filterbarpop-bg" @click="closeDialog1" :style="{'top': 0 + 'px'}"></div>
      <div class="filterbarpop">
        <div class="tab-bar" v-show="hasTabHeader">
          <a href="javascript:;" :style="{'flex': column}" role="button" @click="clickTab(tab, index)" v-for="(tab, index) in menu.tabs"
            :class="{'selected': selectIndexTab == index}" :key="index"><span :class="tab.icon"></span>{{tab.name}}</a>
        </div>
        <div class="main" id="main" ref="main">
          <div class="main-sidebar" style="background:#f3f3f3" :class="{'full-line': !items,'bg-style':items,'line-style':!items,}">
            <div v-if="menu.type !== 'filter'" class="item" @click="clickSidebar(sidemenu, index)" v-for="(sidemenu, index) in sideMenus.detailList"
              :class="{'selected': currentSelectIndex == index}" :key="index">
              <span :class="sidemenu.icon"></span>{{ sidemenu.name }}
            </div>
            <!-- <filter-items @clickFilterbar="clickFilterbar" v-if="menu.type == 'filter'" v-for="(sm, _index) in menu.tabs" :thisIndex="_index" :sm="sm" :key="_index"></filter-items> -->
            <div class="filter-items" ref="filterItems" v-if="menu.type == 'filter'" v-for="(sm, _index) in menu.tabs" :key="_index">
              <div class="filter-name">{{sm.name}}</div>
              <div :class="{isInput:true,errorInput:inputIsError}" v-if="sm.isInput == true">
                <input class="minPrice" type='number' pattern="\d*" placeholder="最低价格" @blur="inputChange(sm,_index)">
                <span>—</span>
                <input class="maxPrice" type='number' pattern="\d*" placeholder="最高价格" @blur="inputChange(sm,_index)">
              </div>
              <div class="filter-item">
                <span v-for="(sidemenu, index) in sm.detailList" class="item-operation" @click="clickFilterbar(sm, _index, index)" :class="{'multi-selected': sidemenu.selectIndex == index}" :key="index">
                  {{ sidemenu.name }}
                </span>
              </div>
            </div>

            <div v-if="menu.type == 'filter'" class="filter-btns">
              <span @click="handleClean">不限条件</span>
              <span @click="handleEnsure">确定</span>
            </div>
          </div>
          <div class="main-list line-style" v-if="items">
            <span class="item" @click="clickItem(item, index)" v-for="(item, index) in items.list" :class="{'selected': currentSelectIndex == sideMenus.selectIndex && items.selectIndex == index}"  :key="index">{{item.name}}</span>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import FilterItems from './FilterItems'
  import { setTimeout } from 'timers';
  export default {
    props: {
      menu: {
        type: Object
      },
      scrollLength: [String,Number],
      showDialog: {
        type: Boolean,
        default: true
      },
      hasTabHeader: {
        type: Boolean,
        default: true
      },
      filterTop: {
        type: String
      },
    },
    data() {
      return {
        inputNotNull:true,
        selectIndexTab: 0,
        currentSelectIndex: 0,
        sideMenus: {},
        items: {},
        column: '',
        visible: false,
        top: 1,
        bgTop: 0,
        range: {},
        theWindowTop: '',
        filterType: '',
        theRange: '',
        inputIsError: false,
      }
    },
    mounted() {

      this.bgTop = document.querySelector('.filterbar').offsetHeight + this.filterTop / 1;
    },
    watch: {
      showDialog(v) {
        this.visible = v;

        if (v) {
          //初始化数据
          this.initData();
        }
      },
      menu(m) {
        //根据tabs数量计算列宽
        this.column = '0 0 ' + 100 / m.tabs.length + '%';
        //初始化数据
        this.initData();
      }
    },
    methods: {
      //初始化数据
      initData(tabIndex) {
        var _this = this;
        // 计算 筛选框高度  secondHandHouse inMap
        if(document.getElementById('sHH')||document.getElementById('inMap')||document.getElementById('searchResult')){
          this.$parent.$parent.calculateHeight(_this);
        }
        //确认是否为多选项
        if(this.$parent.thisTabSelect.type == 'filter'){
          //遍历已保存数据 给选中项设置selectIndex添加选中效果 并将当前this.range重置为已选数据
          var theRange = {};
          var that = this;
          var fifty = setTimeout(() => {
            for(var i in that.$parent.conditionSelect){
              if(that.$parent.thisTabSelect.name == that.$parent.conditionSelect[i].name){
                for(var j in that.$parent.conditionSelect[i].value){
                  theRange[j] = {name:that.$parent.conditionSelect[i].value[j].name,value:{}};
                  for(var k in that.$parent.conditionSelect[i].value[j].value){
                    if(that.menu.tabs[j].detailList[k].value == that.$parent.conditionSelect[i].value[j].value[k].value){
                      that.menu.tabs[j].detailList[k].selectIndex = k;

                      theRange[j].value[k] = that.$parent.conditionSelect[i].value[j].value[k];
                    }
                  }
                  if(that.menu.tabs[j].isInput == true) {

                    var minPrice = this.$refs.filterItems[j].children[1].children[0];
                    var maxPrice = this.$refs.filterItems[j].children[1].children[2];
                    that.inputNotNull = true;
                    for(var x in that.menu.tabs[j].detailList){
                      //如果选项有选中 input 为空
                      if(that.menu.tabs[j].detailList[x].selectIndex == parseInt(x)) {
                        that.inputNotNull = false;
                      }
                    }
                    //添加input数据
                    if(that.inputNotNull == true) {
                      var seat = that.$parent.conditionSelect[i].value[j].value[0].value.indexOf("-");
                      if(seat == that.$parent.conditionSelect[i].value[j].value[0].value.length) {
                        minPrice.value = that.$parent.conditionSelect[i].value[j].value[0].value.split("-")[0];
                      }else if(seat == 0){
                        maxPrice.value = that.$parent.conditionSelect[i].value[j].value[0].value.split("-")[0];
                      }else {
                        minPrice.value = that.$parent.conditionSelect[i].value[j].value[0].value.split("-")[0];
                        maxPrice.value = that.$parent.conditionSelect[i].value[j].value[0].value.split("-")[1];
                      }
                      if(minPrice.value.length!=0&&maxPrice.value.length!=0){
                        theRange[j].value[0] = {value:minPrice.value + "-" + maxPrice.value,text:minPrice.value + "-" + maxPrice.value+"万元"};
                      }else if(!minPrice.value.length!=0&&maxPrice.value.length!=0) {
                        theRange[j].value[0] = {value:"-" + maxPrice.value,text:maxPrice.value+"以下"};
                      }else if(minPrice.value.length!=0&&!maxPrice.value.length!=0){
                        theRange[j].value[0] = {value:minPrice.value + "-",text:minPrice.value + "以上"};
                      }
                    }
                  }
                }
              }
            }
            this.range = theRange;
          }, 50);

        }

        this.filterType = this.menu.type;
        var tmpTabIndx = 0;
        tabIndex === undefined ? tmpTabIndx = this.menu.selectIndex : tmpTabIndx = tabIndex
        //判断tabindex的范围是否在数组内
        if (tmpTabIndx >= 0 && tmpTabIndx < this.menu.tabs.length) {
          this.selectIndexTab = tmpTabIndx;
        } else {
          this.selectIndexTab = 0;
        }
        //确认选中tab的一级列表
        this.sideMenus = this.menu.tabs[this.selectIndexTab];
        //如果当前选中tab是对应选中结果的tab
        // debugger;
        if (this.selectIndexTab == this.menu.selectIndex) {
          this.currentSelectIndex = this.sideMenus.selectIndex;
        }
        // else{
        //   this.sideMenus.selectIndex = -1;
        //   this.currentSelectIndex = -1;
        // }
        //判断是否包含二级列表，包含则赋值
        //如果一级列表的选中状态正确，则查询二级列表
        if (this.currentSelectIndex >= 0 && this.currentSelectIndex < this.sideMenus.detailList.length) {
          //判断是否有二级列表
          if (this.sideMenus.detailList[this.currentSelectIndex].list) {
            this.items = this.sideMenus.detailList[this.currentSelectIndex];
          } else {
            //不显示二级列表
            this.items = false;
          }
        } else { //如果一级列表选中状态不正确，按第一项的的数据判断
          //判断是否有二级列表
          if (this.sideMenus.detailList[0].list) {
            //显示空的二级列表
            this.items = [];
          } else {
            //不显示二级列表
            this.items = false;
          }
        }

        this.$emit('initData');
      },
      //修改选项
      changeSelect(index) {
        //记录tabIndex
        this.menu.selectIndex = this.selectIndexTab;
        //记录一级列表选项
        this.sideMenus.selectIndex = this.currentSelectIndex;
        if (this.items) {
          //确认二级列表选项
          this.items.selectIndex = index;
          //显示名称
          if(this.items.list[this.items.selectIndex].name == '全部'){
            this.menu.name = '区域';
          }else {
            this.menu.name = this.items.list[this.items.selectIndex].name;
          }

          this.menu.value = this.items.list[this.items.selectIndex].value;
        } else {
          //显示名称
          // this.menu.name = this.sideMenus.detailList[this.sideMenus.selectIndex].name;
          this.menu.value = this.sideMenus.detailList[this.sideMenus.selectIndex].value;
        }
        this.$emit('changeSelect');
        this.closeDialog();
      },
      // 筛选修改选项
      changeRangeSelect() {
        let rangeNum = 0;
        let rangeValue = [];
        for(var i in this.range){
          if(Object.keys(this.range[i].value).length == 0){
            delete this.range[i]
          }
        }
        for(let i in this.range){
          for(let j in this.range[i].value){
            rangeValue.push(this.range[i].value[j].text);
          }
          if(this.range[i].value){
            rangeNum++;
          }
        }
        //判断选项选中状态 显示到tab

        if(rangeNum == 0){
          // 未选中
          if(this.menu.tabs[0].name == '价格区间（万元）'){
            this.menu.name = "价格";
          }else if(this.menu.tabs[0].name == '房型选择'){
            this.menu.name = "户型";
          }else if(this.menu.tabs[0].name == '建筑面积（㎡）'){
            this.menu.name = "更多";
          }
        }else if(rangeNum == 1) {
          // 判断单项选中是否为全部
          if(rangeValue == '全部'){
            if(this.menu.tabs[0].name == '价格区间（万元）'){
              this.menu.name = "价格";
            }else if(this.menu.tabs[0].name == '房型选择'){
              this.menu.name = "户型";
            }else if(this.menu.tabs[0].name == '建筑面积（㎡）'){
              this.menu.name = "更多";
            }
          }else {
            this.menu.name = rangeValue[0];
          }
        }else {
          // 判断多项选项是否为全部
          let theValueIsAll = 0;
          for(let h = 0;h<rangeValue.length;h++){
            if(rangeValue[h]!="全部"){
              theValueIsAll++;
              this.menu.name = rangeValue[h];
            }else{

            }
          }
          if(theValueIsAll > 1){
            this.menu.name = "多选";
          }else if(theValueIsAll == 1){

          }else {
            this.menu.name = "更多";
          }

        }

        this.menu.value = Object.keys(this.range).length > 0 ? this.range : '';
        this.$emit('changeSelect');
        // debugger
        this.closeDialog();
      },
      // 选择Tab菜单
      clickTab(tab, index) {
        if (index !== this.selectIndexTab) {
          //根据选中的tab初始化数据
          this.initData(index);
          this.$emit('changeTab', {
            tab,
            index
          })
        }
      },
      inputChange(v,I) {
        var minPrice = this.$refs.filterItems[I].children[1].children[0];
        var maxPrice = this.$refs.filterItems[I].children[1].children[2];
        if(minPrice.value.length!=0||maxPrice.value.length!=0){
          // this.clearnRange();
          // 如果有input数据 清除当前range和span选中
          this.menu.tabs[v.selectIndex].detailList.map(_item => {
            _item.selectIndex = -1;
          })
          delete this.range[v.selectIndex];
          // 将input值添加到range
          if(!this.range[I]){
            this.range[I] = {name: v.name, value: {}};
            if(minPrice.value.length!=0&&maxPrice.value.length!=0) {
              //大小比较
              if(parseFloat(minPrice.value)>parseFloat(maxPrice.value)){
                // this.inputIsError = true;
                var a = minPrice.value;
                minPrice.value = maxPrice.value;
                maxPrice.value = a;
                this.range[I].value[0]={value : minPrice.value + "-" + maxPrice.value,text : minPrice.value + "-" + maxPrice.value + "万元"};
              }else {
                // this.inputIsError = false;
                this.range[I].value[0]={value : minPrice.value + "-" + maxPrice.value,text : minPrice.value + "-" + maxPrice.value + "万元"};
              }

            }else if(minPrice.value.length!=0) {
              this.range[I].value[0]={value : minPrice.value + "-",text : minPrice.value + "以上"};
            }else if(maxPrice.value.length!=0) {
              this.range[I].value[0]={value : "-" + maxPrice.value,text : maxPrice.value + "以下"};
            }
          }else {

          }
        }
      },
      // 筛选方法
      clickFilterbar(v, I, i) {
        if(this.menu.tabs[I].isInput == true) {
          var minPrice = this.$refs.filterItems[I].children[1].children[0];
          var maxPrice = this.$refs.filterItems[I].children[1].children[2];
          if(minPrice.value.length!=0||maxPrice.value.length!=0) {
            if(v.isInput == true) {
              minPrice.value = '';
              maxPrice.value = '';
              // debugger
            }
            // this.handleClean();

          }

        }


        v.detailList[i].selectIndex = i;

        // if(!this.range[I]){
        //   this.range[I] = {name: v.name, value: {}};
        //   this.range[I].value[i] = v.detailList[i].value;
        // } else {
        //   if(!this.range[I].value[i]){
        //     this.range[I].value[i] = v.detailList[i].value;
        //   } else {
        //     delete this.range[I].value[i];
        //     v.detailList[i].selectIndex = -1;
        //   }
        // }
        if(!this.range[I]){
          this.range[I] = {name: v.name, value: {}};
          this.range[I].value[i] = {value: v.detailList[i].value,text:v.detailList[i].name};
        }else {
          if(!this.range[I].value[i]){
            this.range[I].value = {};
            v.detailList.map(_item => {
              _item.selectIndex = -1;
            })
            this.range[I].value[i] = {value: v.detailList[i].value,text:v.detailList[i].name};
            v.detailList[i].selectIndex = i;
          } else {
            delete this.range[I].value[i];
            v.detailList[i].selectIndex = -1;
          }
        }
      },
      // 点击左侧列表
      clickSidebar(v, i) {
        if (this.currentSelectIndex !== i) {
          this.currentSelectIndex = i;
          //存在二级列表
          if (this.sideMenus.detailList[this.currentSelectIndex].list) {
            this.items = this.sideMenus.detailList[this.currentSelectIndex];
          } else {
            //只有一级列表，记录选项，退出
            this.changeSelect();
          }
          this.$emit('changeMainItem', {
            v,
            i
          });
          // debugger
        }
      },
      // 点击右侧列表
      clickItem(v, i) {
        //只有一级列表，记录选项，退出
        this.changeSelect(i);
      },
      // 关闭弹框
      closeDialog() {
        // 解除滑动禁用
        document.querySelector('body').style.position = "";
        // 关闭弹窗回到顶部  secondHandHouse
        if(document.getElementById('sHH')){
          this.$parent.$parent.closeToTop();
        }

        this.visible = false;
        this.$emit('closeDialog');
      },
      clearnRange(){
        if(document.getElementById('inMap')){
          this.menu.tabs.map(item => {
            item.detailList.map(_item => {
              _item.selectIndex = -1;
            })
          });
          this.range = {};
        }else {
          if(this.menu.type == 'filter') {
            this.menu.tabs.map(item => {
              item.detailList.map(_item => {
                _item.selectIndex = -1;
              })
            });
            this.range = {};
          }
        }

      },
      closeDialog1() {
        //解除滑动禁用
        document.querySelector('body').style.position = "";

        // 关闭弹窗 secondHandHouse
        if(document.getElementById('sHH')){
          this.$parent.$parent.closeWindows(this.scrollLength);
        }

        this.visible = false;
        this.$emit('closeDialog1');
        if(document.getElementById('sHH')){
          window.scrollTo(0,this.scrollLength);
        }

        if(document.getElementById('inMap')){
          this.menu.tabs.map(item => {
            item.detailList.map(_item => {
              _item.selectIndex = -1;
            })
          });

          this.range = {};
        }else {
          if(this.$parent.thisTabSelect.type == 'filter') {
            this.menu.tabs.map(item => {
              item.detailList.map(_item => {
                _item.selectIndex = -1;
              })
            });

            this.range = {};
          }
        }

      },

      // 提交已选内容
      handleEnsure() {
        this.changeRangeSelect();
        this.$emit('changeMainItem', this.range);

        // this.closeDialog();
      },
      // 清除已选内容
      handleClean() {
        for(var y in this.menu.tabs) {
          if(this.menu.tabs[y].isInput == true) {
            var minPrice = this.$refs.filterItems[y].children[1].children[0];
            var maxPrice = this.$refs.filterItems[y].children[1].children[2];
            minPrice.value = '';
            maxPrice.value = '';
          }
        }
        this.menu.tabs.map(item => {
          item.detailList.map(_item => {
            _item.selectIndex = -1;
          })
        });
        this.range = {};
      }
    },
    components: {
      'filter-items': FilterItems
    }
  }

  /**
    TODOS:

    1. 需要一个属性去辨别帅选项
    2. 多选
    3. 添加多选框

   */
</script>

<style lang="less">
  .isInput {
    width: 690px;
    height: 60px;
    margin: 0 0 40px 30px;
  }
  .isInput input {
      width: 305px;
      text-align:center;
      color: #333;
      height: 60px;
      // line-height: 60px;
      outline:none;
      -webkit-appearance: none;
      border-radius: 0;
      border: 1px solid #e4e4e4;
      float: left;
  }
  .isInput span {
    float: left;
    width: 42px;
    display: inline-block;
    text-align: center;
    color: #e4e4e4;
    font-size: 36px;
    line-height: 60px;
    margin: 0 14px;
  }
  .errorInput input {
    border-color: red;
  }
  // .fade-enter-active,
  // .fade-leave-active {
  //   transition: opacity .5s
  // }

  // .fade-enter,
  // .fade-leave-active {
  //   opacity: 0
  // }

  .van-hairline--top-bottom::after {
    border-width: 2px;
  }
  .filterbarpop-wrap {
    // position: fixed;
    width: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
    max-height: 100%;
    .filterbarpop-bg {
      position: fixed;
      z-index: 99;
      top: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      background: rgba(0, 0, 0, 0.3);
    }
    .filterbarpop {
      position: absolute;
      z-index: 999;
      margin-top: 100px;
      width: 100%;
      // border-top: 1px solid #e4e4e4;
      // overflow-y: scroll;
      .tab-bar {
        width: 100%;
        display: flex;
        display: -ms-flexbox;
        display: -moz-box;
        display: -webkit-box;
        display: -webkit-flex;
        flex-directives: row;
        -webkit-flex-direction: row;
        align-items: center;
        -webkit-align-items: center;
        -webkit-box-align: center;
        -moz-box-align: center;
        -ms-flex-align: center;
        height: 40px;
        .selected {
          border-bottom: 2px solid orange;
          box-sizing: border-box;
        }
        a {
          background: #fff;
          height: 100%;
          line-height: 40px;
          text-decoration: none;
          color: #323232;
          text-align: center;
        }
      }
      .mainMaxHeight {
        max-height: 600px;
      }
      .main {
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        -webkit-flex-direction: row;
        background: #fff;
        position: relative;
        border-top: 1px solid #e4e4e4;

        .main-sidebar {
          flex: 0 0 50%;
          overflow: auto;
          width: 100%;
          .filter-items {
            background: #fff;
            .filter-name {
                width: 690px;
                margin-left: 30px;
            }
            .filter-item {
                width: 690px;
                margin-left: 30px;
                border-bottom: 1px solid #e4e4e4;
            }
            &:nth-last-child(2) {
              .filter-item {
                  border-bottom: none;
              }
            }
          }
        }
        .full-line {
          flex: 0 0 100%;
          div {
            text-align: left;
          }
          .item {
            text-align: center!important;
          }
        }
        .item-operation {
          white-space: nowrap;
          display: inline-block;
          width: 151px;
          flex:1;
          text-align: center;
          border-radius: 2px;
          color: #333;
          border: 1px solid #e4e4e4;
          margin-right: 22px;
        }
        .item-operation:nth-child(4n) {
          margin-right: 0;
        }
        .multi-selected {
          background: #338cfd;
          color: #fff !important;
          border: 1px solid transparent;
        }

        .filter-item {
          padding-bottom: 10px;
          span {
            font-size: 24px;
            height: 50px;
            line-height: 50px;
            display: inline-block;
            margin-bottom: 30px;
          }
        }
        .filter-name {
          // padding: 10px 0 10px 10px;
          height: 114px;
          line-height: 114px;
          font-size: 34px;
          text-indent: 30px;
          color: #333;
        }
        .filter-btns {
          position: absolute;
          display: flex;
          display: -webkit-flex;
          flex-direction: row;
          -webkit-flex-direction: row;
          justify-content: space-around;
          -webkit-box-pack: space-around;
          -moz-box-pack: space-around;
          -ms-flex-pack: space-around;
          border-top: 1px solid #e4e4e4;
          width: 100%;
          height: 100px;
          z-index: 9999;
          background: #fff;
          span {
            // display: inline-block;
            width: 280px;
            height: 74px;
            line-height: 74px;
            border-radius: 37px;
            text-align: center;
            text-decoration: none;
            color: #333;
            margin-top: 13px;
            font-size: 30px;
            &:first-child {
              height: 72px;
              line-height: 72px;
              border: 1px solid #e4e4e4;
            }
            &:last-child {
              background: #338cfd;
              color: #fff;
            }
          }
        }
        .main-list {
          flex: 0 0 50%;
          overflow: auto;
          margin-left: 30px;
          span:active {
            background: #f5f5f5;
          }
        }
        .line-style {
          .item {
            height: 100px;
            line-height: 100px;
            font-size: 32px;
            color: #333;
            text-align: left;
            border-bottom: 1px solid #e4e4e4;
            border-width: 3px;
            box-sizing: border-box;
            float: left;
            z-index: 999;
            &:last-child {
              border-bottom: none;
            }
            &.selected {
              color: #338cfd;
              // border-color: orange;
              span {
                color: #338cfd;
              }
            }
            .checkbox {
              position: absolute;
              right: 50px;
              top: 10px;
            }
          }
        }
        .bg-style {
          overflow: auto;
          .item {
            background-color: #f5f5f5;
            color: #333;
            height: 100px;
            line-height: 100px;
            font-size: 32px;
            text-indent: 30px;
            &.selected {
              background-color: #FFF;
            }
          }
        }
        .item {
          display: inline-block;
          height: 40px;
          background: #fff;
          line-height: 40px;
          width: 100%;
          text-decoration: none;
          color: #444;
          span {
            font-size: 14px;
            color: #888;
            margin-right: 10px;
            vertical-align: middle;

          }
          &:active {
            color: #9a9a9a
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/FilterBarPop.vue